module.exports = __webpack_public_path__ + "media/images/reclame-aqui-559b7e931744fec0931429e9a18e62a4.svg";